import { useRef, useEffect } from 'react';

var useComponentDidMount = function () {
    var ref = useRef();
    useEffect(function () {
        ref.current = true;
    }, []);
    return ref.current;
};

export { useComponentDidMount };
